<template>
  <div class="file-key-select-modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="content file-key-modal">
        <div class="pull-right" v-if="!isLoading && showCloseIcon">
          <div class="btn-close" @click="close"></div>
        </div>
        <div class="tab">
          <h3 v-if="!isLoading">Neuer Datensatz auswählen</h3>
          <form @submit.prevent="save()" v-if="!isLoading">
            <p class="explenation">
              Der Datensatz, den Sie als Beispiel für ihren Flow verwenden, ist
              nicht mehr vorhanden. Bitte wählen Sie einen neuen Datensatz aus
              der Liste aus.
            </p>

            <div class="database-dropdown-wrapper">
              <generalDropdown
                className="filter-dropdown"
                v-if="showDatabaseDropDown"
              >
                <template v-slot:selectFilter>
                  <span class="line-clamp">{{ showSelectedDatabase }} </span>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="database in databases"
                    @click="addSelectedDatabase(database)"
                  >
                    {{ database.caption }}
                  </b-dropdown-item>
                </template>
              </generalDropdown>
              <div class="loader-wrapper" v-if="databaseItemLoading">
                <div class="loader-icon"></div>
              </div>
              <p
                class="no-items"
                v-if="
                  !databaseItemLoading &&
                  fileKeyList &&
                  fileKeyList.length === 0
                "
              >
                Für diese Datenbank sind keine Datensätze verfügbar. Bitte
                erstellen Sie einen Eintrag in der Datenbank
              </p>
              <generalDropdown
                className="filter-dropdown"
                v-if="!databaseItemLoading && fileKeyList && fileKeyList.length"
                :isCaretVisible="!databaseItemLoading"
              >
                <template v-slot:selectFilter>
                  <span class="line-clamp">{{ getFileKeyName }} </span>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="fileKey in fileKeyList"
                    :key="fileKey.id"
                    @click="setFileKey(fileKey.id)"
                  >
                    {{
                      showField
                        ? fileKey[showField.name] || fileKey.id
                        : fileKey.id
                    }}
                  </b-dropdown-item>
                </template>
              </generalDropdown>
            </div>
            <div class="footer">
              <button class="btn-black" type="submit">Speichern</button>
            </div>
          </form>
          <div class="loading-container" v-if="isLoading">
            <LoadingSpinner
              loadingCaption="Wird geladen..."
              v-if="isLoading"
              class="outer-loader"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCustomDatabaseItems } from '../../services/axios/data.api.js';
import GeneralDropdown from '../core/general-dropdown.vue';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import { mapGetters } from 'vuex';
import { getDataBaseTableSchema } from '../../services/userTable';

export default {
  name: 'fileKeySelect',
  data() {
    return {
      fileKeyList: null,
      selectedKey: null,
      databaseItemLoading: false,
      selectedDatabase: null,
      isAddDatabase: false,
      allKeys: [],
      databaseItems: {},
      showField: null,
    };
  },
  props: {
    type: String,
    databaseName: [Array, String],
    databaseSchema: [Array, Promise, Function],
    databases: { type: Array, default: [] },
    isLoading: { type: Boolean, default: false },
    showCloseIcon: { type: Boolean, default: false },
  },
  methods: {
    close: function () {
      this.$emit('close');
      this.isAddDatabase = false;
    },
    save: function () {
      this.$emit('save', this.selectedKey, this.selectedDatabase);
      this.isAddDatabase = false;
    },
    getFrontEndNameFormat(name) {
      let regex = /^[0-9]{13}_{1}/gm;
      return name.replace(regex, '');
    },
    getAllBucketKeys: async function () {
      var url = process.env.VUE_APP_DATA_API;
      url += '/loadcurve/keys';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      return await fetch(url, { method: 'get', headers: myHeaders })
        .then((response) => {
          if (response.status == 401)
            throw new Error('Access Token has expired');
          else return response.json();
        })
        .then(async (json) => {
          let keys = json
            .filter((e) => !e.key.includes('_report_'))
            .map((e) => e.key);

          let keyList = [];
          // TODO: get loads from table to and remove request
          keys.forEach((e) => keyList.push({ id: e, name: e }));
          this.allKeys = keyList;
          return 'abc'; //.map((e) => e.key);;
        })
        .catch((e) => {
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          }
        });
    },
    async getTableStart() {
      const databaseNameToGetData = this.getDatabaseNameToGetData;

      if (databaseNameToGetData == null) {
        return;
      }

      try {
        const databaseSchema = await this.databaseSchema();
        let params;
        if (this.type == 'loadprofile' || this.type == 'timeseries') {
          params = '?limit=30';
        } else if (
          databaseSchema &&
          Array.isArray(databaseSchema) &&
          databaseSchema.length
        ) {
          params = '?keys=' + databaseSchema[0].name;
        } else {
          params = '';
        }

        if (databaseNameToGetData) {
          const findDatabase = this.databaseList.find(
            (database) => database.name === databaseNameToGetData
          );
          let schema;
          if (findDatabase && findDatabase.schema) {
            schema = JSON.parse(findDatabase.schema);
          } else {
            const response = await getDataBaseTableSchema(
              databaseNameToGetData,
              true
            );
            if (response && response.status === 200 && response.data) {
              this.$store.commit('SET_DATABASE_SCHEMA', response.data);
              schema = JSON.parse(response.data.data);
            }
          }
          const findShowcaseField = schema.find(
            (el) => el?.settings?.showcaseField
          );
          if (findShowcaseField) {
            this.showField = findShowcaseField;
            params = '?keys=' + findShowcaseField.name;
          }
          const response = await getCustomDatabaseItems(
            databaseNameToGetData,
            params,
            true
          );

          if (
            response.status === 200 &&
            response.data &&
            response.data.items &&
            Array.isArray(response.data.items)
          ) {
            this.databaseItems[databaseNameToGetData] = {
              showField: this.showField,
              items: response.data.items,
            };
            this.fileKeyList = response.data.items;
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        if (error?.data?.message?.includes('does not exist')) {
          this.$emit('updateDatabaseId', databaseNameToGetData);
        }
      }
    },
    setFileKey(newkey) {
      this.selectedKey = newkey;
    },

    async addSelectedDatabase(database) {
      try {
        if (!database && !database.name) return;
        this.selectedDatabase = database.name;
        this.isAddDatabase = true;
        if (this.databaseItems[this.selectedDatabase]) {
          this.fileKeyList = this.databaseItems[this.selectedDatabase].items;
          this.selectedKey = null;
          this.showField = this.databaseItems[this.selectedDatabase].showField;
          return;
        }
        this.databaseItemLoading = true;
        this.showField = null;
        await this.getTableStart();
        this.selectedKey = null;
      } catch (error) {
        console.log(error);
      } finally {
        this.databaseItemLoading = false;
      }
    },
    async onCreated() {
      try {
        this.selectedDatabase = this.databaseName;
        this.$emit('setFileSelectKeyModalLoader', true);
        await this.getTableStart();
      } catch (error) {
        console.log(error);
      } finally {
        this.$emit('setFileSelectKeyModalLoader', false);
      }
    },
    findDatabaseCaption(selectedDatabase) {
      return this.databases.find(
        (database) => database.name === selectedDatabase
      )?.caption;
    },
  },
  created() {
    this.onCreated();
  },
  computed: {
    ...mapGetters({
      databaseList: 'getDatabaseList',
    }),
    user() {
      return this.$store.state.user;
    },
    getFileKeyName() {
      if (this.fileKeyList) {
        if (this.selectedKey) {
          const item = this.fileKeyList.find(
            (fileKey) => fileKey.id == this.selectedKey
          );
          return this.showField
            ? item[this.showField.name] || item.id
            : item.id;
        }
        return 'Wählen Sie ein Datensatz aus der Datenbank aus';
      }
    },
    showDatabaseDropDown() {
      if (
        !this.databaseName ||
        (Array.isArray(this.databaseName) && this.databaseName.length === 0)
      ) {
        return true;
      }
      return false;
    },
    showSelectedDatabase() {
      if (Array.isArray(this.selectedDatabase)) {
        if (this.selectedDatabase.length) {
          return this.findDatabaseCaption(this.selectedDatabase[0].name);
        }
        return 'Datenbank auswählen';
      } else if (this.selectedDatabase) {
        return this.findDatabaseCaption(this.selectedDatabase);
      } else {
        return 'Datenbank auswählen';
      }
    },
    getDatabaseNameToGetData() {
      if (Array.isArray(this.selectedDatabase)) {
        if (this.selectedDatabase.length === 0) {
          return null;
        }
        return this.selectedDatabase[0];
      } else if (this.selectedDatabase) {
        return this.selectedDatabase;
      } else {
        return null;
      }
    },
  },
  components: {
    GeneralDropdown,
    LoadingSpinner,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 30%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  position: fixed;
  left: 35%;
  top: 7%;
  height: fit-content;
  overflow: unset; /*For dropdown*/
}
/* Style that has no refference*/
.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: #70787e;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #fff;
  padding: 38px 40px 2px 40px;
  min-height: 190px;
}

select {
  width: 70%;
}
/* Style that has no refference*/
.date {
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: hidden;
}
/* Style that has no refference*/
.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.btn-black {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-bottom: 25px;
  margin-top: 5px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.btn-black:hover {
  color: #fff;
  border: 3px solid #353434;
  background-color: #353434;
}
/* Style that has no refference*/
ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}
/* Style that has no refference*/
/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .datetime {
}

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  color: #70787e;
  margin: 25px 0px 25px 0px;
}

.tab .explenation {
  font-size: 13px;
  margin: 0 0 10px 0;
}
/* Style that has no refference*/
.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.input-group > select {
  margin-right: 0;
  border-radius: 0 3px 3px 0;
}

label {
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #464d5d;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 300;
  width: 50%;
}

input,
select {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}
/* Style that has no refference*/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/*Switch*/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.option-list {
  clear: both;
  float: left;
  position: relative;
  width: 100%;
}

.option-list > ul {
  padding: 0;
  margin: 0;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  list-style: none;
}

.option-list ul li {
  float: left;
  clear: both;
  width: 100%;
  border-bottom: 1px solid #d8dee6;
  padding: 15px 0;
  font-size: 14px;
  color: #7e8890;
  line-height: 35px;
}

.option-list ul li.active {
  color: #323a45;
}

.switch-group {
  height: 65px;
  width: 105%;
}

.switch-group > label.caption {
  float: left;
  height: 53px;
  padding-top: 19px;
}

.radioOption {
  width: 100%;
  padding-bottom: 5px;
}

.radioOption .tools {
  padding: 15px;
  float: right;
}

.radioOption .tools .i {
  font-size: 15px;
}

.radioOption input {
  border: 0;
  background: transparent;
}

.radioOption input[type='text'] {
  width: 68%;
  margin-left: 9px;
  display: inline;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
  height: 43px;
  font-size: 15px;
}

.radioOption input[type='radio'] {
  width: 21px;
  float: left;
  margin-bottom: 0;
  height: 19px;
}

.new-item {
  border: 0;
  background: transparent;
  font-size: 15px;
}

.new-item::placeholder {
  text-decoration: underline;
}

.new-item:focus::placeholder {
  color: transparent;
}

.new-item:focus {
  background: #fff;
}

.message-container {
  height: fit-content;
}

.message-container p {
  margin: 0;
  font-weight: 600;
}

.message-container .error {
  color: rgb(255, 51, 102);
}

.message-container .success {
  color: #52b266;
}

.access-management {
  padding: 0 0px 40px 0px;
}

.col- {
  padding-right: 10%;
  font-size: 14px;
}
.col-.access-level select {
  border: none;
  outline: none;
  margin-top: 14px;
}

.col-.tools {
  margin-top: 25px;
}

.modal .content .tab .filter-dropdown ::v-deep .btn {
  width: fit-content;
  padding: 0;
  margin-bottom: 10px;
}
.file-key-modal ::v-deep .dropdown-menu {
  width: 100%;
}

.file-key-select-modal-wrapper .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

.file-key-select-modal-wrapper .loader-wrapper {
  margin: 0 auto;
}
.file-key-select-modal-wrapper .loader-icon {
  display: block;
  width: 36px;
  height: 36px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #000;
  border-color: #000 transparent #000 transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
}
.file-key-select-modal-wrapper .database-dropdown-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}
.file-key-select-modal-wrapper .no-items {
  margin: 0px 0px 10px 0px !important;
}

.file-key-select-modal-wrapper .filter-dropdown {
  width: 100%;
}
.file-key-select-modal-wrapper .filter-dropdown .line-clamp {
  width: unset;
}
</style>
